export const PROJECT_COLUMNS = {
	name: "name",
	status: "color_mkwka4ma",
	deadline: "date_mks0v125",
	ziflow: "text_mkszj5vz",
	statusGlobal: "lookup_mkrwre0h",
	timeline: "lookup_mks0kzm6",
	ziflowStatus: "color_mksz7ae2",
	channels: "board_relation_mkqpc845",
	products: "board_relation_mkv7bz2x",
} as const;
